import React from 'react';

import RegisterPageContent from '../components/registerPageContent';

const Register = () => {
  return <RegisterPageContent />;
};

export default Register;
